exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.Label */\n.uu5-forms-text-input {\n  position: relative;\n}\n.uu5-forms-text-input.uu5-common-disabled input {\n  box-shadow: none;\n  color: #303030;\n  cursor: not-allowed;\n  background-color: #eee;\n  opacity: 1;\n}\n.uu5-forms-input-loading .uu5-forms-text-input.uu5-common-disabled input {\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n  background-color: transparent;\n}\n.uu5-forms-input-form-item-textarea {\n  resize: vertical;\n  height: inherit;\n  padding: 0.45em 0.8em;\n}\n.uu5-forms-text-glyphicon-link {\n  position: absolute;\n  width: 2.4em;\n  height: 2.4em;\n}\n.uu5-forms-input-hidden-div {\n  visibility: hidden;\n  height: 0;\n  overflow: hidden;\n}\n.uu5-forms-input-auto-resize-textarea,\n.uu5-forms-input-hidden-textarea {\n  overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/internal/text-input.less
// module id = 325
// module chunks = 0